/** Počty kol, ze kterých jde turnaj vybrat. */
export const TOURNAMENT_ROUNDS = [3, 5, 7];
/** Pauza mezi koly turnaje (ms) – na prohlédnutí výsledků. */
export const TOURNAMENT_BREAK_MS = 8000;

export interface TournamentScore {
  points: number;
  wins: number;
  damage: number;
}

export interface TournamentStanding extends TournamentScore {
  id: string;
  name: string;
}

export interface TournamentInfo {
  id: string;
  round: number;
  rounds: number;
  finished: boolean;
  winnerId: string | null;
  /** Seřazeno od prvního místa. */
  standings: TournamentStanding[];
  /** Kdy se spustí další kolo (serverový čas), pokud už je založené. */
  nextStartsAt: number | null;
}

/** Body za kolo: poslední 0, každé lepší místo o bod víc (vítěz n − 1). */
export function roundPoints(placement: number | null, players: number): number {
  if (placement === null || placement < 1) return 0;
  return Math.max(0, players - placement);
}

/** Pořadí: body → výhry kol → způsobená škoda. */
export function sortStandings<T extends TournamentScore>(rows: T[]): T[] {
  return rows.slice().sort((a, b) => b.points - a.points || b.wins - a.wins || b.damage - a.damage);
}

/** Vítěz turnaje, nebo null při úplné shodě na prvním místě. */
export function tournamentWinner<T extends TournamentScore & { id: string }>(rows: T[]): string | null {
  const [a, b] = sortStandings(rows);
  if (!a) return null;
  if (b && a.points === b.points && a.wins === b.wins && a.damage === b.damage) return null;
  return a.id;
}
